/**
 * @module AEM
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Component, OnDestroy } from '@angular/core';
import { AuthorableComponent } from '../../models/authorable-component.model';
import { ByodFaqAuthorable, FaqItem } from './models/byod-faq-authorable';

@Component({
  selector: 'tmo-byod-faq-authorable',
  templateUrl: './byod-faq-authorable.component.html',
})
export class ByodFaqAuthorableComponent
  extends AuthorableComponent<ByodFaqAuthorable>
  implements OnDestroy
{
  /**
   * Stores the value of faqLimit.
   */
  public faqLimit: number;

  /**
   * Stores the boolean value to show all byod faq
   */
  public showAll: boolean;

  /**
   * Stores the seeMoreLabel for the data to be displayed
   */
  public seeMoreLabel: String;
  /**
   * Stores the seeLessLabel for the data to be displayed
   */
  public seeLessLabel: String;
  /**
   * Stores the seeAllLabel for the data to be displayed
   */
  public seeAllLabel: String;
  /**
   * Stores the items for the data to be displayed
   */
  public items: FaqItem[];

  /**
   * Stores FAQ List.
   */
  public showFaqList: FaqItem[];
  /**
   * styling to be applied on the page
   */
  public css: string;

  constructor() {
    super();
    // TODO: value should come from AEM
    const faqLimit = 4;
    this.faqLimit = faqLimit;
    this.showAll = false;
  }

  /**
   * Destroys the configuration for the credit Check Result Page
   * @returns: void
   */
  public ngOnDestroy(): void {}

  /**
   * Method to set data in ByodFaqAuthorable
   * @param data : this will store the data that need to be set in ByodFaqAuthorable
   * @returns void
   */
  public setData(data: ByodFaqAuthorable): void {
    if (this.validate(data)) {
      this.seeMoreLabel = data.seeMoreLabel;
      this.seeLessLabel = data.seeLessLabel;
      this.seeAllLabel = data.seeAllLabel;
      this.items = data.items;
      this.css = data.css;
      this.filterFaq();
    }
  }

  /**
   * Check if the data is valid, should throw an error if the input doesn't match designated fields
   * @param data : data that needs to be validated
   * @returns boolean
   */
  public validate(data: ByodFaqAuthorable): boolean {
    if (!data.seeMoreLabel && !data.seeLessLabel && !data.seeAllLabel) {
      throw new Error(`Invalid options for text ${data}: Required fields [text]`);
    }
    return true;
  }

  /**
   * Shows the full Faq list available
   * @returns void
   */
  public getAllFaq(): void {
    this.showAll = !this.showAll;
    this.showFaqList = this.items;
  }

  /**
   * Shows the Faq list based on the filter applied
   * @returns void
   */
  public showLessFaq(): void {
    this.showAll = !this.showAll;
    this.filterFaq();
  }

  /**
   * Filters the faq list according to the limit specified
   * @returns void
   */
  public filterFaq(): void {
    this.showFaqList = this.items.filter((item: FaqItem, index: number) => index < this.faqLimit);
  }
}
